import React, { useEffect, useState } from "react";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import axiosInstance from '../config/axiosConfig';
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  TextField,
  Checkbox,
  FormControlLabel,
  Pagination,
  Menu
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";
import GetAppIcon from "@mui/icons-material/GetApp";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import SearchIcon from "@mui/icons-material/Search";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import * as XLSX from "xlsx";


export default function DataCollected() {
  const navigate = useNavigate();
  const apiRef = useGridApiRef();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [openFilters, setOpenFilters] = useState(false);
  const [openColumns, setOpenColumns] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const [submenu, setSubmenu] = useState(null);
  const [page, setPage] = useState(0);
  const pageSize = 20;

  const [uniqueDepartamentos, setUniqueDepartamentos] = useState([]);
  const [uniqueMunicipios, setUniqueMunicipios] = useState([]);
  const [uniquePeriodos, setUniquePeriodos] = useState([]);
  const [uniqueNivelesGob, setUniqueNivelesGob] = useState([]);

  const [selectedAprobado, setSelectedAprobado] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState([]);
  const [selectedDepto, setSelectedDepto] = useState([]);
  const [selectedMuni, setSelectedMuni] = useState([]);
  const [selectedNivelGob, setSelectedNivelGob] = useState([]);


  const [columns, setColumns] = useState([
    {
      field: 'action',
      headerName: 'Detalles',
      width: 90,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <img
          src="/images/lupa.png"
          alt="Detalles"
          onClick={() => navigate(`/datos/${params.row.id}`)}
          style={{
            width: "24px",
            height: "24px",
            cursor: "pointer",
          }}
        />
      ),
    },
    { field: 'aprobado', headerName: 'Aprobado', width: 90, renderCell: (params) => params.value === 1 ? '✔' : '✘' ,disableColumnMenu: true},
    { field: 'tecnico', headerName: 'Tecnico', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'fecha', headerName: 'Fecha', minWidth: 120, flex: 1 ,disableColumnMenu: true},
    { field: 'periodo', headerName: 'Periodo', width: 150 ,disableColumnMenu: true},
    { field: 'departamento', headerName: 'Departamento', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'municipio', headerName: 'Municipio', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'indice_gob', headerName: 'Indice de Gobernanza', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'nivel_gob', headerName: 'Nivel de Gobernanza', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'nivel_part', headerName: 'Nivel de Participacion', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'nivel_equid', headerName: 'Nivel de Equidad', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'nivel_transp', headerName: 'Nivel de Transparencia', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'nivel_efic', headerName: 'Nivel de Eficiencia', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'nivel_capresp', headerName: 'Nivel de Capacidad de Respuesta', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'nivel_cord', headerName: 'Nivel de Coordinacion', minWidth: 150, flex: 1 ,disableColumnMenu: true},
    { field: 'nivel_marco_reg', headerName: 'Nivel de Marco Regulatorio', minWidth: 150, flex: 1 ,disableColumnMenu: true},
  ]);
  

  const [columnVisibility, setColumnVisibility] = useState(
    columns.reduce((acc, col) => {
      acc[col.field] = true;
      return acc;
    }, {})
  );

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenu(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get('/Data');
        const data = response.data;
        
        setRows(data);
        setFilteredRows(data);

        setUniqueDepartamentos([...new Set(data.map((r) => r.departamento))]);
        setUniqueMunicipios([...new Set(data.map((r) => r.municipio))]);
        setUniquePeriodos([...new Set(data.map((r) => r.periodo))]);
        setUniqueNivelesGob([...new Set(data.map((r) => r.nivel_gob))]);
      } catch (err) {
        console.error('Error al obtener datos:', err);
    }
  };
   fetchData();
}, []);

  // aplicar filtros y búsqueda
  useEffect(() => {
    let filtered = rows;

    if (selectedAprobado.length > 0) {
      filtered = filtered.filter((row) =>
        selectedAprobado.includes(String(row.aprobado))
      );
    }
    if (selectedPeriodo.length > 0) {
      filtered = filtered.filter((row) =>
        selectedPeriodo.includes(row.periodo)
      );
    }
    if (selectedDepto.length > 0) {
      filtered = filtered.filter((row) =>
        selectedDepto.includes(row.departamento)
      );
    }
    if (selectedMuni.length > 0) {
      filtered = filtered.filter((row) =>
        selectedMuni.includes(row.municipio)
      );
    }
    if (selectedNivelGob.length > 0) {
      filtered = filtered.filter((row) =>
        selectedNivelGob.includes(row.nivel_gob)
      );
    }

    // filtro de búsqueda
    if (searchText) {
      const lowerSearch = searchText.toLowerCase();
      filtered = filtered.filter((row) =>
        columns.some(
          (col) =>
            columnVisibility[col.field] &&
            String(row[col.field] || "").toLowerCase().includes(lowerSearch)
        )
      );
    }

    setFilteredRows(filtered);
  }, [
    rows,
    selectedAprobado,
    selectedPeriodo,
    selectedDepto,
    selectedMuni,
    selectedNivelGob,
    searchText,
    columnVisibility,
  ]);

const handleExportCSV = (type, selectedData = null) => {
  let dataToExport = [];

  if (type === "all") {
    dataToExport = filteredRows;
  } else if (type === "page") {
    const start = page * pageSize;
    const end = start + pageSize;
    dataToExport = filteredRows.slice(start, end);
  } else if (type === "selected") {
    dataToExport = selectedData || [];
  }

  const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

  const csvContent = [
    visibleColumns.map((c) => c.headerName).join(","),
    ...dataToExport.map((row) =>
      visibleColumns.map((c) => row[c.field]).join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "datos.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


const handleExportXLSX = (type, selectedData = null) => {
  let dataToExport = [];

  if (type === "all") {
    dataToExport = filteredRows;
  } else if (type === "page") {
    const start = page * pageSize;
    const end = start + pageSize;
    dataToExport = filteredRows.slice(start, end);
  } else if (type === "selected") {
    dataToExport = selectedData || [];
  }

  const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

  // Transformar los datos en un arreglo de objetos con keys visibles
  const exportData = dataToExport.map((row) => {
    const obj = {};
    visibleColumns.forEach((col) => {
      obj[col.headerName] = row[col.field];
    });
    return obj;
  });

  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Datos");

  XLSX.writeFile(wb, "datos.xlsx");
};

const handleExportWord = (type, selectedData = null) => {
  let dataToExport = [];

  if (type === "all") dataToExport = filteredRows;
  else if (type === "page") dataToExport = filteredRows.slice(page * pageSize, (page + 1) * pageSize);
  else if (type === "selected") dataToExport = selectedData || [];

  const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

  let htmlContent = "<table border='1'><thead><tr>";
  visibleColumns.forEach((col) => { htmlContent += `<th>${col.headerName}</th>`; });
  htmlContent += "</tr></thead><tbody>";
  dataToExport.forEach((row) => {
    htmlContent += "<tr>";
    visibleColumns.forEach((col) => { htmlContent += `<td>${row[col.field]}</td>`; });
    htmlContent += "</tr>";
  });
  htmlContent += "</tbody></table>";

  const blob = new Blob([htmlContent], { type: "application/msword" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "datos.doc");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleExportXML = (type, selectedData = null) => {
  let dataToExport = [];

  if (type === "all") dataToExport = filteredRows;
  else if (type === "page") dataToExport = filteredRows.slice(page * pageSize, (page + 1) * pageSize);
  else if (type === "selected") dataToExport = selectedData || [];

  const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

  let xmlContent = '<?xml version="1.0" encoding="UTF-8"?>\n<rows>\n';
  dataToExport.forEach((row) => {
    xmlContent += "  <row>\n";
    visibleColumns.forEach((col) => {
      xmlContent += `    <${col.field}>${row[col.field]}</${col.field}>\n`;
    });
    xmlContent += "  </row>\n";
  });
  xmlContent += "</rows>";

  const blob = new Blob([xmlContent], { type: "application/xml" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "datos.xml");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  

  const filteredMunicipios =
    selectedDepto.length > 0
      ? [
          ...new Set(
            rows
              .filter((r) => selectedDepto.includes(r.departamento))
              .map((r) => r.municipio)
          ),
        ]
      : uniqueMunicipios;

  return (
    <div style={{ height: "90%", width: "100%", overflowX: "auto", padding: "10px" }}>
      {/* Toolbar */}
      <Box sx={{ display: "flex", gap: 2, marginBottom: 2, flexWrap: "wrap" }}>
        <Button
          variant="outlined"
          startIcon={<FilterListIcon />}
          onClick={() => setOpenFilters(true)}
        >
          Filtros
        </Button>

        {/* Botón Exportar como menú */}
        <Button
          variant="outlined"
          startIcon={<GetAppIcon />}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          Exportar
        </Button>

<Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleMenuClose}
>
  {["all", "page", "selected"].map((type) => (
    <MenuItem
      key={type}
      onMouseEnter={() => setSubmenu(type)}
      onMouseLeave={() => setSubmenu(null)}
    >
      {type === "all" && "Todos los registros"}
      {type === "page" && "Solo la página actual"}
      {type === "selected" && "Datos seleccionados"}

      <ArrowRightIcon fontSize="small" style={{ marginLeft: "auto" }} />

      {submenu === type && (
        <Menu
          anchorEl={anchorEl}
          open
          onClose={() => setSubmenu(null)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={() => {
          if (type === "selected") {
            const selectedRows = Array.from(apiRef.current.getSelectedRows().values());
            handleExportCSV("selected", selectedRows);
          } else {
            handleExportCSV(type);
          }
          handleMenuClose();
        }}>CSV</MenuItem>

          <MenuItem onClick={() => {
  if (type === "selected") {
    const selectedRows = Array.from(apiRef.current.getSelectedRows().values());
    handleExportXLSX("selected", selectedRows);
  } else {
    handleExportXLSX(type);
  }
  handleMenuClose();
}}>Excel</MenuItem>

          <MenuItem onClick={() => {
  if (type === "selected") {
    const selectedRows = Array.from(apiRef.current.getSelectedRows().values());
    handleExportWord("selected", selectedRows);
  } else {
    handleExportWord(type);
  }
  handleMenuClose();
}}>Word</MenuItem>
          <MenuItem onClick={() => {
  if (type === "selected") {
    const selectedRows = Array.from(apiRef.current.getSelectedRows().values());
    handleExportXML("selected", selectedRows);
  } else {
    handleExportXML(type);
  }
  handleMenuClose();
}}>XML</MenuItem>
        </Menu>
      )}
    </MenuItem>
  ))}
</Menu>


        <TextField
          size="small"
          placeholder="Buscar..."
          InputProps={{
            startAdornment: <SearchIcon />,
          }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        <Button
          variant="outlined"
          startIcon={<ViewColumnIcon />}
          onClick={() => setOpenColumns(true)}
        >
          Columnas
        </Button>
      </Box>

      {/* Drawer para filtros */}
      <Drawer anchor="right" open={openFilters} onClose={() => setOpenFilters(false)}>
        <Box sx={{ width: 300, p: 2 }}>
          <h3>Filtros</h3>

          {/* Aprobado */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Aprobado</InputLabel>
            <Select
              multiple
              value={selectedAprobado}
              onChange={(e) => setSelectedAprobado(e.target.value)}
              input={<OutlinedInput label="Aprobado" />}
            >
              <MenuItem value="1">✔</MenuItem>
              <MenuItem value="0">✘</MenuItem>
            </Select>
          </FormControl>

          {/* Periodo */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Periodo</InputLabel>
            <Select
              multiple
              value={selectedPeriodo}
              onChange={(e) => setSelectedPeriodo(e.target.value)}
              input={<OutlinedInput label="Periodo" />}
            >
              {uniquePeriodos.map((p, i) => (
                <MenuItem key={i} value={p}>
                  {p}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Departamento */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Departamento</InputLabel>
            <Select
              multiple
              value={selectedDepto}
              onChange={(e) => {
                setSelectedDepto(e.target.value);
                setSelectedMuni([]);
              }}
              input={<OutlinedInput label="Departamento" />}
            >
              {uniqueDepartamentos.map((d, i) => (
                <MenuItem key={i} value={d}>
                  {d}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Municipio */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Municipio</InputLabel>
            <Select
              multiple
              value={selectedMuni}
              onChange={(e) => setSelectedMuni(e.target.value)}
              input={<OutlinedInput label="Municipio" />}
              disabled={!filteredMunicipios.length}
            >
              {filteredMunicipios.map((m, i) => (
                <MenuItem key={i} value={m}>
                  {m}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Nivel Gobernanza */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Nivel Gobernanza</InputLabel>
            <Select
              multiple
              value={selectedNivelGob}
              onChange={(e) => setSelectedNivelGob(e.target.value)}
              input={<OutlinedInput label="Nivel Gobernanza" />}
            >
              {uniqueNivelesGob.map((n, i) => (
                <MenuItem key={i} value={n}>
                  {n}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{ mb: 2 }}
            onClick={() => {
              setSelectedAprobado([]);
              setSelectedPeriodo([]);
              setSelectedDepto([]);
              setSelectedMuni([]);
              setSelectedNivelGob([]);
            }}
          >
            Limpiar filtros
          </Button>
        </Box>
      </Drawer>

      {/* Drawer de columnas */}
      <Drawer anchor="right" open={openColumns} onClose={() => setOpenColumns(false)}>
        <Box sx={{ width: 250, p: 2 }}>
          <h3>Columnas</h3>
          {columns.map((col) => (
            <FormControlLabel
              key={col.field}
              control={
                <Checkbox
                  checked={columnVisibility[col.field]}
                  onChange={(e) =>
                    setColumnVisibility((prev) => ({
                      ...prev,
                      [col.field]: e.target.checked,
                    }))
                  }
                />
              }
              label={col.headerName}
            />
          ))}
        </Box>
      </Drawer>

      {/* Tabla */}
      <div style={{ minWidth: 1800 }}>
        <DataGrid
          apiRef={apiRef}
          rows={filteredRows}

          columns={columns}
          columnVisibilityModel={columnVisibility}
          onColumnVisibilityModelChange={(newModel) => setColumnVisibility(newModel)}
          
          pagination
          pageSizeOptions={[10]}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => setPage(model.page)}
          checkboxSelection
          disableSelectionOnClick
          // hideFooter
        />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={Math.ceil(filteredRows.length / pageSize)}
          page={page + 1}
          onChange={(e, value) => setPage(value - 1)}
          color="primary"
          shape="rounded"
        />
      </Box>
      </div>
    </div>
  );
}